import { render, staticRenderFns } from "./liveRegistration.vue?vue&type=template&id=5dceff7a&scoped=true&"
import script from "./liveRegistration.vue?vue&type=script&lang=js&"
export * from "./liveRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dceff7a",
  null
  
)

export default component.exports